import { AngularSvgIconModule } from 'angular-svg-icon';
import { ChangeDetectionStrategy, Component, OnInit, WritableSignal, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomComponentModule } from '../../../components';
import { DynamicSubfeatureDirective, MenuTile, MenuTileSubfeature, TileMenuService } from '@ebeihilfe/core';
import { FormatRouteService } from '../../../services/format-route/format-route.service';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'portal-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [CommonModule, AngularSvgIconModule, TranslateModule, DynamicSubfeatureDirective, CustomComponentModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent implements OnInit {
  private readonly tileMenuService = inject(TileMenuService);
  private readonly formatRouteService = inject(FormatRouteService);
  private readonly router = inject(Router);

  public tilesByRows: WritableSignal<MenuTile[][]> = signal([]);

  public async ngOnInit(): Promise<void> {
    const tilesByRowsRaw = await this.tileMenuService.getTilesByRows(3);
    const tilesByRowsFormatted = tilesByRowsRaw.map((row) =>
      row.map(
        (tile) =>
          ({
            ...tile,
            route: this.formatRouteService.formatRoute(tile.route),
          }) as MenuTile,
      ),
    );

    this.tilesByRows.set(tilesByRowsFormatted);
  }

  public generateIds(tileId: number, subFeature: MenuTileSubfeature[]): string {
    return subFeature.map((_, idx) => `portal-dashboard-a11y-${tileId}-${idx}`).join(' ');
  }

  public handleTileNavigation(tile: MenuTile): void {
    if (tile.link != null) {
      window.open(tile.link, '_blank');
      return;
    }

    const route = tile.route;

    if (typeof route === 'string') {
      this.router.navigateByUrl(route);
    } else {
      this.router.navigate(route);
    }
  }
}
